import React from "react";
import { Container, Row } from "react-bootstrap";
import { FaBriefcase, FaCode } from "react-icons/fa";
import { story } from "../../data/story";

function OurStory() {
  return (
    <Container fluid className="about-section" id="ourstory">
      <Container>
        <Row style={{ justifyContent: "center", padding: "10px" }}>
          <h1 className="project-heading" style={{ marginTop: 0 }}>
            <span className="gradient-text">Our Story</span>
          </h1>
          <p style={{ color: "var(--text-body)", textAlign: "center" }}>
            My journey through work, projects, and education.
          </p>
        </Row>

        <div className="timeline-container glass-card" style={{ maxWidth: 780, margin: "0 auto" }}>
          {story.experience.map((job, i) => (
            <div className="timeline-item" key={`job-${i}`}>
              <div className="timeline-dot" style={{ background: "var(--primary)" }}></div>
              {job.duration ? (
                <span className="time-badge">{job.duration}</span>
              ) : (
                <span className="time-badge">
                  {job.startDate} – {job.endDate}
                </span>
              )}
              <h3>
                <FaBriefcase style={{ color: "var(--primary)", marginRight: 8, fontSize: "1.1rem" }} />
                {job.company}
              </h3>
              <p style={{ color: "var(--secondary)", marginBottom: 4, fontWeight: 500, fontSize: "0.95rem" }}>
                {job.position}
              </p>
              {job.projectDetails && (
                <p style={{ color: "var(--text-muted)", fontSize: "0.85rem", marginBottom: 10 }}>
                  {job.projectDetails}
                </p>
              )}
              <ul style={{ paddingLeft: 18 }}>
                {job.responsibilities.map((point, j) => (
                  <li
                    key={j}
                    style={{
                      color: "var(--text-body)",
                      fontSize: "0.9rem",
                      marginBottom: 6,
                      listStyle: "disc",
                    }}
                  >
                    {point}
                  </li>
                ))}
              </ul>
            </div>
          ))}

          {story.projects.map((project, i) => (
            <div className="timeline-item" key={`proj-${i}`}>
              <div className="timeline-dot" style={{ background: "#10b981" }}></div>
              <h3>
                <FaCode style={{ color: "#10b981", marginRight: 8, fontSize: "1.1rem" }} />
                {project.name}
              </h3>
              <p style={{ color: "var(--text-body)", fontSize: "0.9rem", marginBottom: 10 }}>
                {project.description}
              </p>
              {project.url && (
                <a
                  href={project.url}
                  target="_blank"
                  rel="noreferrer"
                  style={{ color: "var(--primary)", fontSize: "0.85rem", marginBottom: 10, display: "inline-block" }}
                >
                  {project.url}
                </a>
              )}
              {project.technologies && (
                <div className="tags">
                  {project.technologies.map((tech) => (
                    <span className="tag" key={tech}>
                      {tech}
                    </span>
                  ))}
                </div>
              )}
            </div>
          ))}

          {story.education.map((item, i) => (
            <div className="timeline-item" key={`edu-${i}`}>
              <div className="timeline-dot" style={{ background: "var(--secondary)" }}></div>
              <span className="time-badge">
                {item.startDate ? `${item.startDate} – ` : ""}
                {item.endDate}
              </span>
              <h3>{item.degree}</h3>
              <p style={{ color: "var(--secondary)", marginBottom: 4, fontWeight: 500, fontSize: "0.95rem" }}>
                {item.institution}
              </p>
              <p style={{ color: "var(--text-muted)", fontSize: "0.85rem", marginBottom: 10 }}>
                {item.university || item.board}
              </p>
              {item.specialization && (
                <p style={{ color: "var(--text-body)", fontSize: "0.9rem", marginBottom: 10 }}>
                  {item.specialization}
                </p>
              )}
              {item.score && (
                <span className="time-badge" style={{ background: "rgba(16,185,129,0.12)", color: "#10b981" }}>
                  {item.score}
                </span>
              )}
            </div>
          ))}
        </div>
      </Container>
    </Container>
  );
}

export default OurStory;